export default __webpack_public_path__ + "static/media/iconFavoritado.13992fba.svg";